import React from 'react';
import { GenericTextInput } from '../..';
import { Field } from 'react-final-form';
import { useTranslation } from '../translationContext';

const TableFilterTextBox = ({ mask, field, inputRef, onChange }) => {
  const { t } = useTranslation();
  return (
    <Field
      name={field}
      component={GenericTextInput}
      labels={t('tablefilter.defaultplaceholder')}
      ariaLabel={t(`tablefilter.defaultplaceholder.${field}`)}
      mask={mask}
      forwardRef={true}
      inputOnChange={onChange}
      ref={inputRef}
    />
  );
};

export default TableFilterTextBox;
